import { ClientAuthProvider } from "@crm/access/auth/session-auth";
import { authClient } from "@crm/access/auth/client";
import appCss from "@crm/ui/styles/tokens.css?url";
import { RegistryProvider } from "@effect/atom-react";
import { createRootRouteWithContext, HeadContent, Outlet, Scripts } from "@tanstack/react-router";
import { Toaster } from "sonner";

export type WorkbenchRouterContext = {};

export const Route = createRootRouteWithContext<WorkbenchRouterContext>()({
  head: () => ({
    meta: [{ title: "imiker 学员工作台" }],
    links: [{ rel: "stylesheet", href: appCss }],
  }),
  component: RootComponent,
  notFoundComponent: WorkbenchNotFound,
});

function WorkbenchNotFound() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 text-center">
      <div className="space-y-4">
        <p className="font-semibold text-primary text-sm">404</p>
        <h1 className="font-semibold text-2xl">页面不存在</h1>
        <p className="text-muted-foreground">你访问的页面不存在或已被移除。</p>
        <a className="inline-flex rounded-md bg-primary px-4 py-2 text-primary-foreground" href="/">
          返回工作台
        </a>
      </div>
    </main>
  );
}

function RootComponent() {
  const { data: session } = authClient.useSession();
  const accountKey = session?.user?.id ?? "anonymous";

  return (
    <html lang="zh-CN">
      <head>
        <HeadContent />
      </head>
      <body>
        <RegistryProvider key={accountKey}>
          <ClientAuthProvider>
            <Outlet />
          </ClientAuthProvider>
        </RegistryProvider>
        <Toaster richColors position="top-center" />
        <Scripts />
      </body>
    </html>
  );
}
